import { render, staticRenderFns } from "./AssessmentCard.vue?vue&type=template&id=4ec1ab58&scoped=true"
import script from "./AssessmentCard.vue?vue&type=script&lang=js"
export * from "./AssessmentCard.vue?vue&type=script&lang=js"
import style0 from "./AssessmentCard.vue?vue&type=style&index=0&id=4ec1ab58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec1ab58",
  null
  
)

export default component.exports